export const downloadObject = (exportObj, exportName, format) => {
  let newExportObj = JSON.stringify(exportObj);
  if (format === "csv") {
    newExportObj = exportObj;
  }
  const dataStr = `data:text/${format};charset=utf-8,${encodeURIComponent(
    newExportObj,
  )}`;
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", `${exportName}.${format}`);
  downloadAnchorNode.setAttribute("data-belongsto", "metalens-dropdown");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};

export const deleteFromBlockMetadataMap = (blockMetadataMap, metadataId) => {
  if (blockMetadataMap) {
    Object.keys(blockMetadataMap).forEach(blockKey => {
      blockMetadataMap[blockKey] = blockMetadataMap[blockKey].filter(
        mention => mention.metadataId !== metadataId,
      );
    });
  }
  return blockMetadataMap;
};



// WEBPACK FOOTER //
// ./src/utils/metalensUtils.js